var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", [_c("a-modal", {
    attrs: {
      title: _vm.$t("注销账号") + _vm.$t("确认"),
      "ok-text": _vm.$t("确认注销"),
      "cancel-text": _vm.$t("取消"),
      visible: _vm.visible,
      maskClosable: false,
      width: 560
    },
    on: {
      ok: _vm.confirmModal,
      cancel: _vm.cancleModal
    }
  }, [_c("div", {
    staticClass: "tips"
  }, [_vm._v("*" + _vm._s(_vm.$t("该操作将注销账号，注销后该账号将无法登录，请确认是否继续操作，并进行账号校验")))]), _c("verifyTab", {
    ref: "verifyRef",
    attrs: {
      way: "logOff",
      visibleEditModal: _vm.visible
    }
  })], 1)], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };